import { createScene3D, createQuad } from '../helpers/3DEngineHelper'
import { createShaderMat, createTexture } from '../helpers/MaterialHelper'

const vertexShader = `
attribute vec3 position;
void main() { gl_Position = vec4(position, 1.0); }`

const fragmentShader = `
precision mediump int;
precision highp float;

uniform sampler2D map;
uniform float loadingOpacity;
uniform vec2 resolution;
uniform float time;
uniform float radius;
const vec4 loadingLayer = vec4(0.0, 0.0, 0.0, 1.0);

void main() {
  vec2 st = gl_FragCoord.xy / resolution;
  vec3 vignette = vec3(smoothstep(1.0, abs(length(st - vec2(0.5))), radius + cos(time * 0.0018) * 0.01));
  gl_FragColor = mix(texture2D(map, st), loadingLayer, loadingOpacity) - vec4(vignette, 0.0);
}`

/**
 * class Screen
 */
class Screen {
  /**
   * constructor
   */
  constructor (texture) {
    const text = texture || createTexture()
    this._loadingOpacity = 1.0
    this.scene3D = createScene3D()
    this.uniforms = {
      map: { value: text },
      loadingOpacity: { value: this.loadingOpacity },
      resolution: { value: [0, 0] },
      radius: { value: 0.9 },
      time: { value: 0 }
    }
    this.quad = createQuad(createShaderMat({
      vertexShader,
      fragmentShader,
      uniforms: this.uniforms
    }, true))
    this.scene3D.add(this.quad)
  }

  get loadingOpacity () { return this._loadingOpacity }
  set loadingOpacity (value) {
    // glsl mix function bug when loading opacity uniform set to 0
    this._loadingOpacity = Math.max(value, 0.01)
    this.uniforms.loadingOpacity.value = this._loadingOpacity
  }

  set radius (value) {
    this.uniforms.radius.value = value
  }

  setTexture (texture) {
    this.uniforms.map.value = texture
  }

  setSize (width, height) {
    this.uniforms.resolution.value = [width, height]
  }

  update (time) {
    this.uniforms.time.value = time
  }

}
export default Screen


// WEBPACK FOOTER //
// ./src/scripts/webgl/Screen.js